import React from 'react'

import VScroll from '../../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll'
import {templatesLibrary} from "../../../config/library"

type Props = {
    selectedCategory: ID

    onCategorySelect: func
}

export default class SharedTemplatesBlock extends React.Component<Props> {

    onCategoryClick = (id: ID) => {
        this.props.onCategorySelect(id)
    }

    render() {
        const { selectedCategory } = this.props;

        return (
            <VScroll className="templates-library">
                {_.map(templatesLibrary, (g,key)=>
                    <div key        = {key}
                         className  = {Classes('template-category-row',{'selected': g.id === selectedCategory})}
                         onClick    = {this.onCategoryClick.bind(this, g.id)}>
                        <div className='template-category-title'>
                            {g.name}
                        </div>
                    </div>
                )}
            </VScroll>
        )
    }
}